import { CardProductId, CreditCardStatusCode } from '__generated__/GQL';

import { isCreditCardFragment } from '../../../../hooks/usePaymentCardsList';
import { PaymentCardListTable_ItemFragment } from '../../../../hooks/usePaymentCardsList/paymentCardsList.gql';
import locales from './locales';

export const getCardKey = (
  card: PaymentCardListTable_ItemFragment,
): 'physical' | 'virtual' | 'virtualTemporary' | 'budget' => {
  if (isCreditCardFragment(card)) {
    if (!card.isPhysical && card.deactivateAt) {
      return 'virtualTemporary';
    }
  }

  if (card.isPhysical) {
    return 'physical';
  }

  /**
   * @todo(https://linear.app/shine/issue/CPA-1809)
   * Replace the check using cardProductId with cardProductType
   */
  if (card.cardProductId === CardProductId.Budget) {
    return 'budget';
  }

  return 'virtual';
};

export const getCardName = (card: PaymentCardListTable_ItemFragment) => {
  if (card.alias) {
    return card.alias;
  }

  return locales.cardProductType[getCardKey(card)];
};

export const isPendingCard = (card: PaymentCardListTable_ItemFragment) => {
  return [
    CreditCardStatusCode.Inactive,
    CreditCardStatusCode.Stolen,
    CreditCardStatusCode.Deactivated,
    CreditCardStatusCode.Lost,
    CreditCardStatusCode.Locked,
  ].includes(card.status);
};
